import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProcessDevice from './ProcessDevice';
import OurProductsSection from "./OurProductsSection"

import '../styles/ElectronicsIndustry.css';

import ElectronicsIndustryImg from '../assets/ElectronicsIndustryImg.jpg'

const ElectronicsIndustry = () => {

  return (
    <div className="ElectronicsIndustry">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner7">
        <div className="hero-content">
          <h1>AUTOMOBILES AND PARTS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Automobiles And Parts</span>
          </div>
        </div>
      </section> */}

<section className="ElectronicsIndustry-hero-clean">
  <div className="hero-text">
    <h1>Electronics Industry</h1>
    <p>
      Our products help you meet the requirements from intralogistics and traceability, robotics, handling and assembly technology to machine vision and condition monitoring.
    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={ElectronicsIndustryImg} alt="Electronics Industry" />
  </div>
</section>


<ProcessDevice />
<OurProductsSection />

      <Footer />
    </div>
  );
};
export default ElectronicsIndustry;